import { ACTIVITY_STATUS } from '@repo/ui';
import classnames from 'classnames';
import React, { useState } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';

import TableActivityByStatus from './datatable-container';

export const ActivitiesTabs = () => {
  //States
  const [customActiveTab, setcustomActiveTab] = useState<string>('1');

  //Functions
  const toggleCustom = (tab: string) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h5 className="fw-semibold">Atividades</h5>
        </CardHeader>
        <CardBody>
          <Nav tabs className="nav nav-tabs nav-tabs-custom nav-success mb-3">
            <NavItem>
              <NavLink
                style={{ cursor: 'pointer' }}
                className={classnames({
                  active: customActiveTab === '1',
                })}
                onClick={() => {
                  toggleCustom('1');
                }}
              >
                Em andamento
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: 'pointer' }}
                className={classnames({
                  active: customActiveTab === '2',
                })}
                onClick={() => {
                  toggleCustom('2');
                }}
              >
                Perdidas
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: 'pointer' }}
                className={classnames({
                  active: customActiveTab === '3',
                })}
                onClick={() => {
                  toggleCustom('3');
                }}
              >
                Concluídas
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: 'pointer' }}
                className={classnames({
                  active: customActiveTab === '4',
                })}
                onClick={() => {
                  toggleCustom('4');
                }}
              >
                Agendadas
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={customActiveTab} className="text-muted">
            {[
              {
                id: 1,
                label: 'Em andamento',
                activityStatus: ACTIVITY_STATUS.STARTED,
              },
              {
                id: 2,
                label: 'Perdidas',
                activityStatus: ACTIVITY_STATUS.MISSED,
              },
              {
                id: 3,
                label: 'Concluídas',
                activityStatus: ACTIVITY_STATUS.FINISHED,
              },
              {
                id: 4,
                label: 'Agendadas',
                activityStatus: ACTIVITY_STATUS.SCHEDULED,
              },
            ].map((item) => {
              return (
                <TabPane tabId={item.id.toString()} key={item.id}>
                  <TableActivityByStatus activityStatus={item.activityStatus} />
                </TabPane>
              );
            })}
          </TabContent>
        </CardBody>
      </Card>
    </React.Fragment>
  );
};
